import axios from "axios";
import { Message } from "element-ui";

if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = "/api";
} else {
    axios.defaults.baseURL = "";
}

// 50s超时,预防网不好，本公司网不太好
axios.defaults.timeout = 50000;

// post头
axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

// 响应拦截
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data && response.data.code > 0) 
            {
                return Promise.resolve(response);
            } 
            else 
            {
                // Message.error(response.data.msg || "操作失败");
                Message.error(response.data.msg);
                return Promise.reject(response);
            }
        } else {
            Message.error("网络异常");
            return Promise.reject(response);
        }
    },
    error => {
        Message.error("网络异常");
        return Promise.reject(error.response);
    }
);
